<ng-container *ngFor="let fee of fees; let i = index">
  <app-booking-fee-form
    [fees]="fees"
    [index]="i"
    [currencyCode]="currencyCode"
    (remove)="onRemove(i)"
  ></app-booking-fee-form>
</ng-container>

<div class="add-fee-box">
  <button (click)="onAdd()" class="btn btn-success text-uppercase" type="button">
    <i class="fal fa-plus"></i>
    <ng-container i18n>Add Fee</ng-container>
  </button>

  <div class="rental-selector-box">
    <span i18n>Copy fees from:</span>
    <app-select-search
      bindLabel="name"
      floatLabel="never"
      [multiple]="false"
      [items]="rentals$ | async"
      [ctrl]="rentalCtrl"
      class="rental-selector"
      placeholder="Rental"
      i18n-placeholder
    ></app-select-search>
    <button
      [disabled]="!rentalCtrl.value"
      (click)="onCopy(rentalCtrl.value)"
      class="btn btn-success text-uppercase"
      type="button"
    >
      <i class="fal fa-copy"></i>
      <ng-container i18n>Copy</ng-container>
    </button>
  </div>
</div>

<div class="fees-footers">
  <button (click)="close.emit(true)" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> <ng-container i18n>cancel</ng-container>
  </button>
  <button (click)="save()" [disabled]="processing" type="button" class="btn btn-success text-uppercase create-btn">
    <i *ngIf="!processing" class="fal fa-save"></i>
    <i *ngIf="processing" class="fal fa-spinner fa-spin"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
